/* File: assets/image-collage.js */

(function () {
  'use strict';

  function initCollageSlider(sectionId, options) {
    var track = document.querySelector('[data-track="' + sectionId + '"]');
    if (!track) return;

    var slides      = Array.prototype.slice.call(track.querySelectorAll('.collage-mobile__slide'));
    var dots        = Array.prototype.slice.call(document.querySelectorAll('[data-dot][data-track-target="' + sectionId + '"]'));
    var totalSlides = slides.length;
    var currentIdx  = 0;
    var touchStartX = 0;
    var autoTimer   = null;
    var autoplay    = options.autoplay || false;
    var autoplaySpeed = (options.autoplaySpeed || 4) * 1000;

    if (totalSlides === 0) return;

    function goTo(idx, animate) {
      currentIdx = ((idx % totalSlides) + totalSlides) % totalSlides;

      track.style.transition = animate === false
        ? 'none'
        : 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

      track.style.transform = 'translateX(-' + (currentIdx * 100) + '%)';

      dots.forEach(function (dot, i) {
        var active = i === currentIdx;
        dot.classList.toggle('collage-mobile__dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAuto() {
      if (!autoplay) return;
      clearInterval(autoTimer);
      autoTimer = setInterval(function () {
        goTo(currentIdx + 1, true);
      }, autoplaySpeed);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAuto();
        goTo(parseInt(dot.dataset.dot, 10), true);
        startAuto();
      });
    });

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        stopAuto();
        goTo(diff > 0 ? currentIdx + 1 : currentIdx - 1, true);
        startAuto();
      }
    }, { passive: true });

    track.addEventListener('mouseenter', stopAuto);
    track.addEventListener('mouseleave', startAuto);

    goTo(0, false);
    startAuto();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('[data-slider-id]');
    sliders.forEach(function (el) {
      var id = el.dataset.sliderId;
      var autoplay = el.dataset.autoplay === 'true';
      var speed = parseInt(el.dataset.autoplaySpeed, 10) || 4;
      initCollageSlider(id, { autoplay: autoplay, autoplaySpeed: speed });
    });
  });

})();